module.exports = __webpack_public_path__ + "static/media/cellfinate_banner_resultados_mobile.2a8dbbc4.jpg";